export default __webpack_public_path__ + "b28a4cdc1d55711c536eef14cd76c8d7.jpeg";